const HeaderButton = props => {
    return (<a {...props} className={`kt-header-button ${props.className ?? ""}`}>{props.children}</a>)
}

export default HeaderButton;